import moment from 'moment';
export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYY-MM-DD'), moment(endDt).format('YYYY-MM-DD')];
	},
	hasChanged_({ selectedRow }) {
		const custCd = selectedRow.custCd || '';
		const oldCustCd = selectedRow.oldCustCd || '';
		return custCd !== oldCustCd;
	},
	getFormDatas_({ resultList, selectedRow }, getters) {
		const formData = new FormData();
		//업체 변동 시 플레그값 넣어줌
		if (getters.hasChanged_) formData.set('changeCustCd', 'Y');

		// 마스터 데이터 (단 건) 폼데이터 전환
		for (const [key, val] of Object.entries(selectedRow)) {
			if (!val) continue;
			else formData.set(key, val);
		}

		// 디테일 데이터 (다 건) 폼 데이터 전환
		let index = 0;
		for (const result of resultList) {
			for (const [key, val] of Object.entries(result)) {
				if (!val) continue;
				formData.set(`detailList[${index}].${key}`, val);
			}
			index++;
		}
		return formData;
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001983'), //검사일자
				prop: 'pprrDt',
				minWidth: '100px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001977'), //MES 검사시작
				prop: 'ckuStrtDt',
				minWidth: '170px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001978'), //MES 검사종료
				prop: 'ckuEndDt',
				minWidth: '170px',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001936'), //제품ID No.
				prop: 'pmcNo',
				minWidth: '160px',
				custom: true,
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001379'), //차수
				prop: 'ipnNos',
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001937'), //고객사명
				prop: 'custNm',
				minWidth: '100px',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001374'), //검사항목수
				prop: 'testCnt',
				align: 'right',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001710'), //불합격항목수
				prop: 'ngCnt',
				align: 'right',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001232') + '(%)', //합격율
				prop: 'okRto',
				align: 'right',
				sortable: false
			},
			// {
			// 	label: rootGetters['commonStore/getMessage_']('QWCC001711'), //누락수량
			// 	prop: 'eptCnt'
			// },
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001715'), //출력여부
				prop: 'oputStCd',
				minWidth: '90px',
				form: {
					type: 'select',
					options: state.oputStCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000009'), //검사원
				prop: 'pprrNm',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000008'), //종합판정
				prop: 'jgmtRsltCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001938'), //공정품질코드
				prop: 'powQltyCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001939'), //LOT누락
				prop: 'partBloCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001940'), //결품
				prop: 'partSrgCd',
				minWidth: '70px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001941'), //외관
				prop: 'apenCkuCd',
				minWidth: '70px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001942'), //체결상태
				prop: 'clfcStCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001943') + '/' + rootGetters['commonStore/getMessage_']('QWCC001944'), //배선 / 배관
				prop: 'cdcnStCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					placeholder: ' - ',
					isDisabled: () => true
				},
				align: 'center',
				sortable: false
			}
		];
	},
	getPopupColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpNm',
				minWidth: '90px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.lgrpCdList,
					isDisabled: () => !!state.selectedRow.csetDd
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.sgrpAllList,
					isDisabled: () => !!state.selectedRow.csetDd
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), //항목
				prop: 'ipnPrvsSbc',
				minWidth: '350px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001243'), //중요도
				prop: 'icrtCd',
				minWidth: '1px'
			},
			{
				label: 'SPEC', //SPEC
				children: [
					{
						label: 'MIN', //MIN
						prop: 'minVal',
						minWidth: '100px'
					},
					{
						label: 'MAX', //MAX
						prop: 'maxVal',
						minWidth: '100px'
					}
				]
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.utmCdList,
					isDisabled: () => !!state.selectedRow.csetDd
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001371'), //수치
				prop: 'spcRslt',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001244'), //사진
				prop: 'fwdImgNm',
				minWidth: '150px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002005'), //주의
				prop: 'mark',
				minWidth: '40px',
				custom: true,
				sortable: false
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001125'), //결과
				prop: 'prvsRsltCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					isDisabled: ({ row }) => {
						if (!state.selectedRow.csetDd) return false;
						else return true;
					}
				}
			}
		];
	}
};
